export const Home_Banner = 'home_banner';
export const Home_Policy = 'home_policy';
export const Home_Hotel = 'home_hotel';
export const Category_Banner = 'category_banner';
export const Category_Policy = "category_policy";
export const Product_Banner = 'product_banner';
export const Home_Standing = 1;
export const Home_Origin = 2;
export const Category_Today = 3;
export const Category_BestSale = 4;
export const Category_Discover = 5;
export const Category_TopTrend = 6;

